import MuiChip from "@mui/material/Chip";

export default function Chip(props) {
  return <MuiChip {...props} />;
}
